import React, {useEffect, useState} from 'react';
import {Provider} from 'react-redux';
import './App.scss';
import ClubFinderWidget from "./components/compounds/club-finder-widget/club-finder-widget";
import {Config} from "./constants/Config";
import {store} from "./store/configureStore";


const baseClass = 'clubFinder-appContainer'

function App() {
  const [breakpointClass, setBreakpointClass] = useState('');
  const [widgetParentWidth, setWidgetParentWidth] = useState(0);
  const [offset, setOffset] = useState('0px');
  const widgetParent = document.getElementsByTagName('phq-club-finder')[0] as HTMLElement;
  const windowHeight = window.innerHeight + 'px';

  const setOffsetValue = (clubFinderOffset: string | undefined) => {
    if(clubFinderOffset) {
      if (clubFinderOffset?.includes('px')) {
        setOffset(clubFinderOffset);
      } else {
        setOffset(`${clubFinderOffset}px`);
      }
    }
  }

  useEffect(() => {
    let widgetWidth;
    if (widgetParent && widgetParent.parentNode) {
      widgetWidth = widgetParent?.parentElement?.offsetWidth
    }
    if (widgetWidth) {
      setWidgetParentWidth(widgetWidth);
      if (Config.breakpoints.small.width > widgetWidth) {
        setBreakpointClass(Config.breakpoints.extraSmall.class);
        setOffsetValue(widgetParent.dataset.clubFinderOffset);
      }
      if (Config.breakpoints.small.width < widgetWidth && Config.breakpoints.medium.width > widgetWidth) {
        setBreakpointClass(Config.breakpoints.small.class);
        setOffsetValue(widgetParent.dataset.clubFinderOffset);
      }
      if (Config.breakpoints.medium.width < widgetWidth && Config.breakpoints.large.width > widgetWidth) {
        setBreakpointClass(Config.breakpoints.medium.class);
        setOffsetValue(widgetParent.dataset.clubFinderOffset);
      }
      if (Config.breakpoints.large.width < widgetWidth && Config.breakpoints.large.width < widgetWidth) {
        setBreakpointClass(Config.breakpoints.large.class);
        setOffsetValue(widgetParent.dataset.clubFinderDesktopOffset);
      }
      if (Config.breakpoints.extraLarge.width < widgetWidth) {
        setBreakpointClass(Config.breakpoints.extraLarge.class);
        setOffsetValue(widgetParent.dataset.clubFinderDesktopOffset);
      }
    }
  }, [widgetParent, widgetParent.dataset]);

  return (
    <Provider store={store}>
      <div className={[baseClass, breakpointClass].join(' ')} style={{'--top-offset': offset, '--window-height': windowHeight} as React.CSSProperties}>
        {widgetParentWidth > 0 && (
          <ClubFinderWidget parentWidth={widgetParentWidth} widgetProps={widgetParent.dataset} breakpointClass={breakpointClass}/>
        )}
      </div>
    </Provider>
  );
}

export default App;
